import { UI_VERSION_KEY } from "./uiVersion";

class StoreClass {
    get(key) {
      return localStorage.getItem(key);
    }
  
    set(key, value) {
      localStorage.setItem(key, value);
    }
  
    remove(key) {
      localStorage.removeItem(key);
    }
  
    // Keeps the chosen UI version (new/classic) across logout
    clearAll() {
      const uiVersion = localStorage.getItem(UI_VERSION_KEY);
      localStorage.clear();
      if (uiVersion) localStorage.setItem(UI_VERSION_KEY, uiVersion);
    }
  }
  
  export default new StoreClass();
  